export class TrafficNewsFilter {
    constructor(stateFilterContainer, infoTypeFilterContainer, items) {
        this.stateFilterContainer = stateFilterContainer;
        this.infoTypeFilterContainer = infoTypeFilterContainer;
        this.items = items;
        this.initListeners();
        this.initResetButton();
    }
    initListeners() {
        this.initFilterGroup(this.stateFilterContainer);
        this.initFilterGroup(this.infoTypeFilterContainer);
    }
    initFilterGroup(container) {
        container.addEventListener('click', event => {
            const target = event.target;
            if (target.tagName !== 'BUTTON')
                return;
            const btn = target;
            const value = btn.getAttribute('data-value');
            if (!value)
                return;
            const isActive = btn.classList.toggle('active');
            btn.setAttribute('aria-pressed', String(isActive));
            this.applyFilter();
        });
    }
    initResetButton() {
        const resetBtn = document.querySelector('.traffic-news-filter__reset');
        if (!resetBtn)
            return;
        resetBtn.addEventListener('click', e => {
            e.preventDefault();
            this.resetFilters();
        });
    }
    getActiveValues(container) {
        return Array.from(container.querySelectorAll('button.active'))
            .map(btn => btn.getAttribute('data-value'))
            .filter(Boolean);
    }
    showNoResultsMessage(show) {
        var _a;
        const filterWrapper = document.querySelector('.traffic-news__wrapper');
        let msgEl = document.querySelector('.js-no-results-message');
        if (!msgEl) {
            msgEl = document.createElement('h3');
            msgEl.classList.add('js-no-results-message', 'no-results-message');
            msgEl.textContent = 'Derzeit gibt es keine Meldungen für diesen Filter.';
            msgEl.hidden = true;
            (_a = filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(msgEl);
        }
        msgEl.hidden = !show;
        filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.classList.toggle('is-hidden', show);
    }
    matchesFilters(item, selectedStates, selectedInfoTypes) {
        const rowStates = (item.getAttribute('data-state') || '').split(' ').map(s => s.toLowerCase());
        const rowInfoType = (item.getAttribute('data-infotype') || '').toLowerCase();
        const filterAllStates = selectedStates.length === 0 || selectedStates.includes('all');
        const filterAllInfoTypes = selectedInfoTypes.length === 0;
        const matchesState = filterAllStates || selectedStates.some(val => rowStates.includes(val.toLowerCase()));
        const matchesInfoType = filterAllInfoTypes || selectedInfoTypes.some(val => val.toLowerCase() === rowInfoType);
        return matchesState && matchesInfoType;
    }
    applyFilter() {
        const selectedStates = this.getActiveValues(this.stateFilterContainer);
        const selectedInfoTypes = this.getActiveValues(this.infoTypeFilterContainer);
        let anyVisible = false;
        this.items.forEach(item => {
            const shouldShow = this.matchesFilters(item, selectedStates, selectedInfoTypes);
            item.classList.toggle('is-hidden', !shouldShow);
            if (shouldShow)
                anyVisible = true;
        });
        this.showNoResultsMessage(!anyVisible);
        const resetBtn = document.querySelector('.traffic-news-filter__reset');
        if (resetBtn) {
            const hasActiveFilter = selectedStates.length > 0 || selectedInfoTypes.length > 0;
            resetBtn.classList.toggle('is-visible', hasActiveFilter);
        }
        this.updateUrlParams(selectedStates, selectedInfoTypes);
    }
    updateUrlParams(selectedStates, selectedInfoTypes) {
        const params = new URLSearchParams();
        selectedStates.forEach(s => params.append('state', s));
        selectedInfoTypes.forEach(t => params.append('info', t));
        const newUrl = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
        history.replaceState({}, '', newUrl);
    }
    resetFilters() {
        const allButtons = document.querySelectorAll('.filter-btn.active');
        allButtons.forEach(btn => btn.classList.remove('active'));
        this.items.forEach(item => item.classList.remove('is-hidden'));
        history.replaceState({}, '', window.location.pathname);
        this.applyFilter();
    }
    applyUrlParamsToFilters() {
        const params = new URLSearchParams(window.location.search);
        const stateParams = params.getAll('state');
        const infoParams = params.getAll('info');
        stateParams.forEach(val => {
            const btn = this.stateFilterContainer.querySelector(`button[data-value="${val}"]`);
            if (btn)
                btn.classList.add('active');
        });
        infoParams.forEach(val => {
            const btn = this.infoTypeFilterContainer.querySelector(`button[data-value="${val}"]`);
            if (btn)
                btn.classList.add('active');
        });
        this.applyFilter();
    }
}
export function initTrafficNewsFilter() {
    const stateFilterContainer = document.querySelector('.state-filter-buttons');
    const infoTypeFilterContainer = document.querySelector('.infotype-filter-buttons');
    const items = document.querySelectorAll('.traffic-news__item');
    if (!stateFilterContainer || !infoTypeFilterContainer || items.length === 0)
        return;
    const filter = new TrafficNewsFilter(stateFilterContainer, infoTypeFilterContainer, Array.from(items));
    filter.applyUrlParamsToFilters();
}
